
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"43","viewBox":"0 0 40 43","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 23.92v7.405L11.714 43 40 29.331v-6.55L12.571 34.457 0 23.921zm28.286-9.682L0 23.921 4.571 7.119 32.286 0l-4 14.238zm-8.572 15.947-6.857 2.848-10-8.828L10 21.642l9.714 8.543zm4.857-7.119c0-.57-1.142-1.139-2.285-1.139-1.143 0-2.286.57-2.286 1.14v4.84c0 .57 1.143.855 2.286.855s2.285-.57 2.285-.855v-4.84zm5.715-2.278c0-.57-.857-.854-2.286-.854-1.143 0-2.286.285-2.286.854v4.556c0 .57.857.855 2 .855s2-.285 2.286-.855v-4.556h.286zm5.428 1.993v-3.986c0-.57-.857-.855-2-.855s-2 .57-2 .855v4.271c0 .57.857.855 2 .855s2-.57 2-1.14zm-16.857-2.278c0-.284-.857-.57-2.286-.57-1.428 0-2.285.286-2.285.57v2.848c0 .285 1.143.57 2.285.57 1.143 0 2-.285 2.286-.57v-2.848zm5.714-1.993c0-.285-.857-.57-2.285-.57-1.429 0-2 .285-2 .57v2.563c0 .285.857.57 2.285.57 1.143 0 2.286-.285 2.286-.57V18.51h-.286zM28 15.947c-1.143 0-2 .285-2 .57v2.562c0 .285.857.57 2 .57s2-.285 2-.57v-2.562c.286-.57-.857-.57-2-.57z","fill":"#999","fill-rule":"nonzero"}})])
          )
        }
      }
    